// import { useTransition } from 'stimulus-use'
import axios from "axios"
import DropdownController from "./dropdown_controller"
const debounce = require("lodash/debounce")

export default class extends DropdownController {
  static targets = ["menu", "input", "list", "searchWait", "searchResults", "help", "error", "navigation", "subContainer"]
  static values = { autoShow: { type: Boolean, default: false } }

  eventCreated = false

  connect() {
    console.log("connect1")
    super.connect()
    this.errorTarget.classList.add("hidden")
    // this.menuTarget.classList.add('hidden')

    // useTransition(this, { element: this.menuTarget })

    this.updateSearchDebounce = debounce(this.updateSearchDebounce, 500).bind(this)

    // przy pierwszym kliknięciu odpytaj serwer jeśli input ma już wartość (np. z params[:q])
    if (this.hasInputTarget) {
      this.inputTarget.addEventListener("focus", () => {
        if (this.inputTarget.value.trim().length > 0) {
          this.updateSearchInfoShow()
          this.updateSearchDebounce({ preventDefault: () => {} })
        }
      }, { once: true })
    }
  }

  openOnly() {
    // otwiera dropdown tylko jeśli jest zamknięty i input ma min. 2 znaki
    if (this.eventCreated === false) {
      if (this.hasInputTarget && this.inputTarget.value.trim().length < 2) return
      this.toggle()
    }
  }

  updateSearchInfoShow() {
    this.errorTarget.classList.add("hidden")
    if (this.hasSearchResultsTarget) {
      this.searchResultsTarget.classList.remove("hidden")
    }
    this.helpTarget.classList.add("hidden")
    this.searchWaitTarget.classList.remove("hidden")
    this.searchWaitTarget.classList.add("block")
  }

  updateSearchInfoHide() {
    this.searchWaitTarget.classList.add("hidden")
    this.searchWaitTarget.classList.remove("block")
  }

  updateSearch(event) {
    console.log(event)
    // Nie odpytuj serwera gdy aktywny tryb AI (kb-ai-ask controller)
    if (this.element.dataset.kbAiAskMode === "ask") return
    // Nie pokazuj wyników gdy mniej niż 2 znaki — zamknij menu jeśli otwarte
    if (this.hasInputTarget && this.inputTarget.value.trim().length < 2) {
      if (this.eventCreated !== false) this.toggle()
      return
    }
    // Otwórz menu jeśli jeszcze nie jest otwarte
    if (this.eventCreated === false) this.toggle()
    this.updateSearchInfoShow()
    this.updateSearchDebounce(event)
  }

  updateSearchDebounce(event) {
    console.log("update")
    const input = this.inputTarget.value
    const url = this.inputTarget.dataset.url
    console.log(encodeURIComponent(input))

    event.preventDefault()

    axios.get(url, {
      params: {
        q: input
      },
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
      .then((response) => {
        console.log("update success")
        // Obejscie do Rails.ajax, wywolujemy skrypt recznie
        const script = document.createElement("script")
        script.textContent = response.data
        document.body.appendChild(script)
        document.body.removeChild(script)
        this.updateSearchInfoHide()
        // pokaż menu z wynikami jeśli jest ukryte (np. gdy focus był programatyczny, bez click)
        if (this.autoShowValue && this.hasMenuTarget && this.menuTarget.classList.contains("hidden")) {
          this.menuTarget.classList.remove("hidden")
        }
        // this.announceChangedSectionToScreenReader()
      })
      .catch((error) => {
        console.log("error updating", error)
        this.errorTarget.classList.remove("hidden")
        this.updateSearchInfoHide()
      })
  }
}
